import React from 'react';
import { flag } from '../config';
import FooterLegacy from './FooterLegacy';
import { SiteFooter, SITE_FOOTER_LINKS } from './site/footer';

/**
 * The footer's navigation under SLOT_MODEL: since the Sept 2026 redesign this is the
 * redesigned footer's list (components/site/footer/footerLinks.js). Kept under its old
 * name for existing imports.
 */
export const SLOT_FOOTER_LINKS = SITE_FOOTER_LINKS;

/**
 * The site footer. SLOT_MODEL on: the redesigned SiteFooter (components/site/footer).
 * SLOT_MODEL off: the pre-redesign footer (FooterLegacy.jsx), markup unchanged.
 * PublicLayout and the chrome sentinel tests mount it by this path.
 */
const Footer = () => (flag('SLOT_MODEL') ? <SiteFooter /> : <FooterLegacy />);

export default Footer;
